import { Button, ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@mui/material';
import React from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { RequiredDocumentsAction } from '.';

interface DocumentActionButtonProps {
	onAdd: (action: RequiredDocumentsAction | null) => void;
	onReorder: (open: boolean) => void;
}

type DocumentActionItem = keyof typeof DocumentActionItemMap;
const DocumentActionItemMap = {
	Add: 'Request document from borrower',
	ReOrder: 'Re-order documents',
};

export const DocumentActionButton: React.FC<DocumentActionButtonProps> = ({ onAdd, onReorder }) => {
	const [open, setOpen] = React.useState(false);
	const anchorRef = React.useRef<HTMLDivElement>(null);

	const handleToggle = () => {
		setOpen(prevOpen => !prevOpen);
	};

	const handleClick = (action: DocumentActionItem) => {
		switch (action) {
			case 'Add':
				onAdd({ type: 'Request' });
				break;
			case 'ReOrder':
				onReorder(true);
				break;
		}
	};

	const handleClose = (event: Event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
			return;
		}

		setOpen(false);
	};

	const handleMenuItemClick = (
		event: React.MouseEvent<HTMLLIElement, MouseEvent>,
		actionItem: DocumentActionItem
	) => {
		setOpen(false);
		handleClick(actionItem);
	};

	return (
		<>
			<ButtonGroup variant="contained" ref={anchorRef} aria-label="split button">
				<Button onClick={handleToggle}>Actions</Button>
				<Button
					size="small"
					aria-controls={open ? 'split-button-menu' : undefined}
					aria-expanded={open ? 'true' : undefined}
					aria-label="select merge strategy"
					aria-haspopup="menu"
					onClick={handleToggle}
				>
					<ArrowDropDownIcon />
				</Button>
			</ButtonGroup>
			<Popper
				open={open}
				style={{ zIndex: 1000, margin: 0 }}
				anchorEl={anchorRef.current}
				role={undefined}
				transition
				disablePortal
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
						}}
					>
						<Paper>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList id="split-button-menu" autoFocusItem>
									<MenuItem onClick={event => handleMenuItemClick(event, 'Add')}>
										{DocumentActionItemMap['Add']}
									</MenuItem>
									<MenuItem onClick={event => handleMenuItemClick(event, 'ReOrder')}>
										{DocumentActionItemMap['ReOrder']}
									</MenuItem>
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</>
	);
};
